<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>讨论答疑</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div
            class="add-btn"
            v-show="false"
          >
          </div>
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
          <!-- <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div> -->
        </div>
      </div>
      <div class="toolbar">
        <div class="tabs">
          <span
            @click="tabsClick(2)"
            :class="{'tabActive':tabsIndex==2}"
          >讨论</span>
          <span
            @click="tabsClick(1)"
            :class="{'tabActive':tabsIndex==1}"
          >答疑</span>
        </div>
        <div class="f-search">
          <input
            type="text"
            v-model="queryInfo.title"
            placeholder="帖子名称"
          >
          <span
            class="f-search-btn"
            @click="search"
          >搜索</span>
        </div>
      </div>
      <p class="forumMsg">截止当前时间，发帖总数：<i>{{statisticObject.all_discuss}}</i>教师发帖数：<i>{{statisticObject.teacher_discuss}}</i>学生发帖数：<i>{{statisticObject.student_discuss}}</i>参与互动人数：<i>{{statisticObject.join_count}}</i></p>
      <div id="list">
        <div
          class="item-list"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div class="top-box">
            <router-link
              class="top-title"
              :to="'/online/discuss/detail?discussId=' + item.id + '&id=' + lessonInfo.id"
            >{{item.title}}</router-link>
            <div>
              <!--              <span class="publish" @click="askRelease(item, 1)">{{item.status?'取消发布':'发布'}}</span>-->
              <template v-if="!item.status">
                <span
                  class="delete"
                  @click="askRelease(item, 2)"
                >删除</span>
                <!--                <span class="edit" @click="discussEdit(item)">编辑</span>-->
                <!--                <span :class="{'disHot':item.isTop}" @click="askRelease(item, 3)">{{item.isTop?'取消置顶':'设为置顶'}}</span>-->
              </template>
            </div>
          </div>
          <div class="details">
            <p v-html="item.content"></p>
          </div>
          <div class="item-tb">
            <span
              class="author"
              v-if="item.createUser_id"
            >{{item.createUser.name}}</span>
            <span
              class="time"
              v-if="item.pubDate"
            >{{timeConversion(item.pubDate)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      style="z-index: 1;"
      :style="classShowDiscussWindow"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel"
        style="width:780px"
      >
        <div class="form_title">帖子</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>标题:</span>
              <input
                type="text"
                v-model="formInfo.title"
                autocomplete="off"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>分类:</span>
              <select v-model="formInfo.disType">
                <option value="1">答疑</option>
                <option value="2">讨论</option>
              </select>
            </div>
            <div class="item">
              <vue-ueditor-wrap
                id="editor3"
                v-model="formInfo.content"
                :config="editorConfig"
                editor-id="editor-demo-3"
              ></vue-ueditor-wrap>
            </div>
          </form>
        </div>
        <div
          class="form_control"
          style="padding-left:240px"
        >
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideDiscussWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="modifyDiscuss"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  components: {
    VueUeditorWrap
  },
  props: ['lessonInfo'],
  data() {
    return {
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      tabsIndex: 2,
      tableData: [],
      tableDataCount: 0,
      queryInfo: {
        page: 1,
        size: 10000,
        disType: 2,
        title: '',
        lessonOnline_id: this.lessonInfo.id
      },
      classShowDiscussWindow: {},
      formInfo: {
        id: 0,
        title: '',
        content: '',
        disType: ''
      },
      statisticInfo: {
        lessonOnline_id: this.lessonInfo.id,
        dis_type: 2
      },
      statisticObject: {},
      sensitiveWord: []
    }
  },

  methods: {
    tabsClick(disType) {
      this.tabsIndex = disType
      this.queryInfo.disType = disType
      this.queryInfo.page = 1
      this.queryInfo.title = ''
      this.statisticInfo.dis_type = disType
      this.search()
      this.getStatistics()
    },
    showDiscussWindow() {
      this.classShowDiscussWindow = {
        visibility: 'visible'
      }
    },
    hideDiscussWindow() {
      this.classShowDiscussWindow = {}
    },
    // 时间转换
    timeConversion(timestamp) {
      var dateTime = new Date(timestamp)
      var no1new = dateTime.valueOf()

      var year = dateTime.getFullYear()
      var month = dateTime.getMonth() + 1
      var day = dateTime.getDate()
      var now = new Date()
      var nowNew = now.valueOf()

      var milliseconds = 0
      var timeSpanStr
      milliseconds = Number(nowNew) - Number(no1new)

      if (milliseconds <= 1000 * 60 * 1) {
        timeSpanStr = '刚刚'
      } else if (1000 * 60 * 1 < Number(milliseconds) && Number(milliseconds) <= 1000 * 60 * 60) {
        timeSpanStr = Math.round((Number(milliseconds) / (1000 * 60))) + '分钟前'
      } else if (1000 * 60 * 60 * 1 < Number(milliseconds) && Number(milliseconds) <= 1000 * 60 * 60 * 24) {
        timeSpanStr = Math.round(Number(milliseconds) / (1000 * 60 * 60)) + '小时前'
      } else if (1000 * 60 * 60 * 24 < Number(milliseconds) && Number(milliseconds) <= 1000 * 60 * 60 * 24 * 15) {
        timeSpanStr = Math.round(Number(milliseconds) / (1000 * 60 * 60 * 24)) + '天前'
      } else if (Number(milliseconds) > 1000 * 60 * 60 * 24 * 15 && year === now.getFullYear()) {
        timeSpanStr = Number(year) + '-' + Number(month) + '-' + Number(day)
      } else {
        timeSpanStr = Number(year) + '-' + Number(month) + '-' + Number(day)
      }
      return timeSpanStr
    },
    // 计算时间间隔
    FunMinutesago(timestamp) {
      var dateTime = new Date(timestamp)
      var no1new = dateTime.valueOf()
      var year = dateTime.getFullYear()
      var month = dateTime.getMonth() + 1
      var day = dateTime.getDate()
      var now = new Date()
      var nowNew = now.valueOf()
      var milliseconds = 0
      var timeSpanStr
      milliseconds = Number(nowNew) - Number(no1new)
      if (milliseconds <= 1000 * 60 * 1) {
        timeSpanStr = '刚刚'
      } else if (1000 * 60 * 1 < Number(milliseconds) && Number(milliseconds) <= 1000 * 60 * 60) {
        timeSpanStr = Math.round((Number(milliseconds) / (1000 * 60))) + '分钟前'
      } else if (1000 * 60 * 60 * 1 < Number(milliseconds) && Number(milliseconds) <= 1000 * 60 * 60 * 24) {
        timeSpanStr = Math.round(Number(milliseconds) / (1000 * 60 * 60)) + '小时前'
      } else if (1000 * 60 * 60 * 24 < Number(milliseconds) && Number(milliseconds) <= 1000 * 60 * 60 * 24 * 15) {
        timeSpanStr = Math.round(Number(milliseconds) / (1000 * 60 * 60 * 24)) + '天前'
      } else if (Number(milliseconds) > 1000 * 60 * 60 * 24 * 15 && year === now.getFullYear()) {
        timeSpanStr = Number(year) + '-' + Number(month) + '-' + Number(day)
      } else {
        timeSpanStr = Number(year) + '-' + Number(month) + '-' + Number(day)
      }
      return timeSpanStr
    },
    // 获取讨论答疑列表
    async search() {
      await this.$http.get('/online_discuss/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取讨论答疑列表失败！')
      })
    },
    // 发布/删除操作
    async askRelease(item, type) {
      // type 1 编辑  2删除 3置顶
      const url = '/online_discuss/' + item.id + '/'
      var tips = ''
      var formData = {}
      var date = new Date()
      const Y = date.getFullYear() + '-'
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
      const pubDate = Y + M + D + h + m
      if (type === 1) {
        formData.status = item.status ? 0 : 1
        formData.pubDate = pubDate
        formData.createUser_id = this.$store.state.userInfo.profile_id
        tips = item.status ? '确认取消发布吗？' : '确认发布吗？'
      } else if (type === 2) {
        formData.isdel = 1
        tips = '确认删除吗？'
      } else if (type === 3) {
        formData.isTop = item.isTop ? 0 : 1
        tips = item.isTop ? '确认取消置顶吗？' : '确认设为置顶吗？'
      }
      await this.$parent.showConfirm(tips, () => {
        this.$http.put(url, formData).then((data) => {
          this.$parent.showMsg('操作成功！')
          this.search()
          this.getStatistics()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('操作失败！')
        })
      })
    },
    // 编辑
    discussEdit(item) {
      this.showDiscussWindow()
      this.formInfo.id = item.id
      this.formInfo.title = item.title
      this.formInfo.disType = item.disType
      this.formInfo.content = item.content
    },
    async modifyDiscuss() {
      const isRight = this.utils.getWords(this.formInfo.content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put('/online_discuss/' + this.formInfo.id + '/', this.formInfo).then((data) => {
        if (data.id) {
          this.$parent.showMsg('修改成功！')
          this.search()
          this.hideDiscussWindow()
        } else {
          this.$parent.$parent.showMsg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('修改失败！')
      })
    },
    // 获取讨论答疑统计信息
    async getStatistics() {
      await this.$http.get('/online_discuss_statistics/', {
        params: this.statisticInfo
      }).then((data) => {
        this.statisticObject = data.data
      }).catch(() => {
        this.$layer.msg('获取讨论答疑统计信息！')
      })
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.search()
    this.getStatistics()
    this.getSensitiveWord()
  },
  computed: {
  }
}
</script>
<style scoped src="@/assets/css/project-detail.css"></style>
<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.itemStatus {
  img {
    width: 120px;
  }
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      margin-bottom: 0;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
.add-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .item {
    .label {
      padding-left: 0;
    }
  }
}
.toolbar {
  margin-bottom: 20px;
  .tabs {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    margin-right: 20px;
    border: 1px solid #c9c9c9;
    span {
      text-align: center;
      width: 51px;
      height: 31px;
      display: inline-block;
      color: #666;
      cursor: pointer;
    }
    .tabActive {
      color: #fff;
      background: #11b38b;
    }
  }
  .f-search {
    display: inline-block;
    input {
      height: 30px;
      border: 1px solid #c9c9c9;
      padding: 0 10px;
    }
    .f-search-btn {
      background: #f9f9f9 none repeat scroll 0 0;
      border: 1px solid #c9c9c9;
      border-left: none;
      color: #555;
      font-size: 14px;
      text-align: center;
      width: 39px;
      height: 30px;
      line-height: 28px;
      display: inline-block;
      cursor: pointer;
    }
  }
}
.forumMsg {
  height: 40px;
  margin-bottom: 10px;
  background: #f1f1f1;
  line-height: 40px;
  text-align: center;
  font-size: 15px;
  i {
    margin-right: 15px;
  }
}
.item-list {
  margin-bottom: 30px;
  border: 1px solid #eee;
  .top-box {
    background: #f9f9f9;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    .top-title {
      color: #333;
      font-size: 16px;
      height: 32px;
      line-height: 32px;
      &:hover {
        color: #009999;
      }
    }
    span {
      display: inline-block;
      height: 32px;
      color: #333;
      line-height: 32px;
      text-decoration: none !important;
      padding: 0 5px;
      cursor: pointer;
      text-align: center;
      &:hover {
        background: #ddd;
      }
    }
    .disHot {
      color: #cc0000;
    }
  }
  .details {
    color: #666;
    display: block;
    padding: 20px;
    line-height: 22px;
  }
  .item-tb {
    height: 20px;
    padding: 0 20px 20px;
    span {
      display: inline-block;
    }
    .author {
      color: #555;
      text-decoration: underline;
      margin-right: 20px;
    }
    .time {
      font-size: 13px;
      color: #999;
    }
  }
}
</style>
